// extracted by mini-css-extract-plugin
export default {"noteSpan":"AutoGrowInput_noteSpan__e2Jzu"};